import { TDocumentDefinitions } from 'pdfmake/interfaces'

export const configPdfMakeDefault = ({
    pageMargins: [20, 40, 20, 40],
    pageOrientation: 'landscape',
    pageSize: 'A4',
    defaultStyle: {
        font: 'THSarabun',
        fontSize: 14,
    },
    styles: {
        table: {
            margin: [0, 15, 5, 0],
        },
        header: {
            fontSize: 20,
            bold: true,
        },
        subheader: {
            fontSize: 18,
            bold: true,
            margin: [0, 10, 0, 5],
        },
        text: {
            fontSize: 14,
            color: '#3B3B3B',
            margin: [10, 5, 5, 10],
        },
        textBold: {
            fontSize: 14,
            color: '#3B3B3B',
            margin: [10, 5, 5, 10],
            bold: true,
        },
        tableExample: {
            margin: [0, 0, 0, 0],
        },
        tableHeader: {
            bold: true,
            fontSize: 14,
            color: 'black',
        },
    },
} as unknown) as TDocumentDefinitions

export const configPdfMakeFullReport = ({
    pageMargins: [20, 40, 20, 40],
    pageOrientation: 'portrait',
    pageSize: 'A4',
    defaultStyle: {
        font: 'THSarabun',
        fontSize: 14,
    },
    styles: {
        table: {
            margin: [0, 15, 5, 0],
        },
        header: {
            fontSize: 20,
            bold: true,
        },
        subheader: {
            fontSize: 18,
            bold: true,
            margin: [0, 10, 0, 5],
        },
        text: {
            fontSize: 14,
            color: '#3B3B3B',
            margin: [10, 5, 5, 10],
        },
        textBold: {
            fontSize: 14,
            color: '#3B3B3B',
            margin: [10, 5, 5, 10],
            bold: true,
        },
        tableExample: {
            margin: [0, 0, 0, 0],
        },
        tableHeader: {
            bold: true,
            fontSize: 14,
            color: 'black',
        },
    },
} as unknown) as TDocumentDefinitions
